module.exports = __webpack_public_path__ + "img/inverter_blue.1bcf7eaf.png";